export const cwreport = window?.cwreport;